/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class GoalLinker extends Component {
  // Services
  @service
  store;

  @service
  strings;

  @service
  toaster;

  subjects = null;
  @tracked
  dialogOpen = false;
  @tracked
  linkType = 'main';
  @tracked
  activeSubject = null;
  @tracked
  activeCategory = null;
  @tracked tab = 'Goals';

  @computed('subjects.@each.{isTopic,visibleToTeachers}')
  get filteredSubjects() {
    if (isEmpty(this.subjects)) {
      return [];
    }
    return this.subjects.filter((subject) => {
      return subject.visibleToTeachers && !subject.isTopic;
    });
  }

  // Compute the tab labels for the PaperTabs component
  @computed('filteredSubjects')
  get subjectsByType() {
    let subjects = this.filteredSubjects; // assuming 'model' is an array of subject objects

    return subjects.reduce((result, subject) => {
      let type = subject.subjectTypeName || '0';
      if (!result[type]) {
        result[type] = [];
      }
      result[type].push(subject);
      return result;
    }, {});
  }

  displayWarning(message) {
    // Display the warning to the user, this could be a toast notification or alert
    this.toaster.error(message);
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
    this.linkType = 'main';
  }

  @action
  openDialog(type) {
    this.dialogOpen = true;
    this.linkType = type;
  }

  @action
  setTab(tab) {
    this.tab = tab;
    this.activeSubject = null;
    this.activeCategory = null;
  }

  @action
  setActiveSubject(subject) {
    this.activeSubject = subject;
    this.activeCategory = null;
  }

  @action
  setActiveCategory(category) {
    this.activeCategory = category;
  }

  // These call back into the parent-supplied actions instead of mutating
  // goalLinkedGoals/goalPriorLinkedGoals/goalFutureLinkedGoals directly -
  // those are plain, reassigned arrays owned by the parent controller, not
  // arrays this component should push/removeObject onto by reference (the
  // parent is what coordinates cross-list removal - see
  // topics/subject.js's toggleLinkedGoal/togglePriorGoal/toggleFutureGoal).
  @action
  handleToggleLinkedGoal(goal) {
    this.toggleLinkedGoal(goal);
  }

  @action
  togglePriorGoal(goal) {
    this.onTogglePriorGoal(goal);
  }

  @action
  toggleFutureGoal(goal) {
    this.onToggleFutureGoal(goal);
  }
}
